<template>
  <div>
    <catalog-select
      ref="catalog_select"
      catalog-name="тип расхода"
      :is-disabled="isDisabled"
      :initial-value="value"
      :get-item-by-id="getWorkerCostType"
      :get-list="getItems"
      :can-create-catalog="canEditWorkerCostType()"
      :drop-up="dropUp"
      @onSelect="$emit('onSelect', $event)"
      @open-modal="isModalVisible = true"
    />

    <worker-cost-type
      v-if="isModalVisible"
      :create-id="0"
      @modal-closed="isModalVisible = false"
      @refresh="onCatalogItemCreated"
    />
  </div>
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import CatalogSelect from "../CatalogSelect.vue";
    import WorkerCostType from "./WorkerCostType.vue";

export default {
  name: "WorkerCostTypeSelect",
  components: { WorkerCostType, CatalogSelect},
  mixins: [
    catalogs,
    permissions,
  ],
  props: {
    isDisabled: { type: Boolean, default: null },
    value: { type: Number, default: null },
    dropUp: { type: Boolean, default: false }
  },
  data() {
    return {
      isModalVisible: false
    }
  },
  methods: {
    async getItems() {
      const result = await this.getWorkerCostTypesSearch('');
      return (result && result.data) ? result.data : [];
    },
    async getWorkerCostType(id) {
      const result = await this.getWorkerCostTypeById(id);
      return (result && result.data) ? result.data : null;
    },
    async onCatalogItemCreated(newItem) {
      this.$refs.catalog_select.onItemCreated(newItem);
      this.isModalVisible = false;
    },
    canEditWorkerCostType() {
      return this.hasPermission([PERM.CATALOG_WORKER_COST_TYPE_EDIT]);
    }
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/WorkerCostTypes/WorkerCostTypeSelect.vue